/**
 * 门户返回默认配置数据
 */
export const home = [{
  "selectBoxShadowH": [],
  "borderColor": {
    "data": {
      "stops": [
        [
          "rgba(61,130,242,1)",
          0
        ],
        [
          "rgba(61,130,242,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(61,130,242,1)"
  },
  "topNavBoxShadowSpread": [],
  "boxShadowBlur": [],
  "activeBgColor": [
    {
      "data": {
        "stops": [
          [
            "rgba(255,255,255,1)",
            0
          ],
          [
            "rgba(246,206,1,1)",
            1
          ]
        ],
        "angle": 0
      },
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "rgba(255,255,255,1)"
    }
  ],
  "topNavBackground": [
    {
      "data": {
        "stops": [
          [
            "rgba(255,255,255,0)",
            0
          ],
          [
            "rgba(246,206,1,1)",
            1
          ]
        ],
        "angle": 0
      },
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "rgba(255,255,255,0)"
    }
  ],
  "selectBoxShadowColor": [],
  "liHoverBgColor": [
    {
      "data": {
        "stops": [
          [
            "rgba(232,242,255,1)",
            0
          ],
          [
            "rgba(246,206,1,1)",
            1
          ]
        ],
        "angle": 0
      },
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "rgba(232,242,255,1)"
    }
  ],
  "boxShadowSpread": [],
  "boxShadowV": [],
  "activeBorderColor": {
    "data": {
      "stops": [
        [
          "rgba(61,130,242,1)",
          0
        ],
        [
          "rgba(61,130,242,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(61,130,242,1)"
  },
  "hoverBorderColor": {
    "data": {
      "stops": [
        [
          "rgba(61,130,242,1)",
          0
        ],
        [
          "rgba(61,130,242,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(61,130,242,1)"
  },
  "topNavBoxShadowColor": [],
  "liActiveBgColor": [
    {
      "data": {
        "stops": [
          [
            "rgba(232,242,255,1)",
            0
          ],
          [
            "rgba(246,206,1,1)",
            1
          ]
        ],
        "angle": 0
      },
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "rgba(232,242,255,1)"
    }
  ],
  "liActiveFontColorArr": {
    "data": {
      "stops": [
        [
          "rgba(107, 107, 131, 1)",
          0
        ],
        [
          "rgba(255, 255, 255, 0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color"
  },
  "hoverFontColorArr": {
    "data": {
      "stops": [
        [
          "rgba(107, 107, 131, 1)",
          0
        ],
        [
          "rgba(255, 255, 255, 0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color"
  },
  "boxShadowH": [],
  "selectOptions": [
    {
      "children": [],
      "label": "首页",
      "value": "/",
      "iconUrl": "",
      "publicId": "39e954be7a0f1311ef28b092133944acb1bc",
      "openTarget": 2,
      "openType": 2,
      "showType": 0
    },
    {
      "children": [
        {
          "children": [],
          "label": "数据列表",
          "value": "",
          "iconUrl": "",
          "publicId": "39ec89105a0f1311ef28b094c572b5a57592",
          "openTarget": 2,
          "openType": 1,
          "showType": 1
        },
        {
          "children": [],
          "label": "数据列表+简介",
          "value": "",
          "iconUrl": "",
          "publicId": "39f7d3b65a0f1311ef28b0934b044fd9b752",
          "openTarget": 2,
          "openType": 1,
          "showType": 3
        },
        {
          "children": [],
          "label": "简介",
          "value": "",
          "iconUrl": "",
          "publicId": "3a047dec8a0f1311ef28b090edf9680bd622",
          "openTarget": 2,
          "openType": 1,
          "showType": 2
        }
      ],
      "label": "新闻公告",
      "value": "",
      "iconUrl": "",
      "publicId": "39eadb5f8a0f1311ef28b09001ee837bca15",
      "openTarget": 2,
      "openType": 2,
      "showType": 2
    },
    {
      "children": [
        {
          "children": [],
          "label": "培训讲座",
          "value": "",
          "iconUrl": "",
          "publicId": "3a073d0e3a0f1311ef28b0937d313536bb60",
          "openTarget": 2,
          "openType": 1,
          "showType": 0
        },
        {
          "children": [],
          "label": "新生专栏",
          "value": "",
          "iconUrl": "",
          "publicId": "3a089c9f1a0f1311ef28b09575ec43f54907",
          "openTarget": 2,
          "openType": 1,
          "showType": 0
        }
      ],
      "label": "学校概况",
      "value": "",
      "iconUrl": "",
      "publicId": "3a05dd7d5a0f1311ef28b09029e92da930fb",
      "openTarget": 2,
      "openType": 1,
      "showType": 1
    },
    {
      "children": [
        {
          "children": [],
          "label": "学校主页",
          "value": "",
          "iconUrl": "",
          "publicId": "3a0ae6916a0f1311ef28b09417eb4ff8893b",
          "openTarget": 2,
          "openType": 1,
          "showType": 0
        },
        {
          "children": [],
          "label": "学校简介",
          "value": "",
          "iconUrl": "",
          "publicId": "3a0c1f122a0f1311ef28b091797b17149caf",
          "openTarget": 2,
          "openType": 1,
          "showType": 0
        },
        {
          "children": [],
          "label": "参观交流",
          "value": "",
          "iconUrl": "",
          "publicId": "3a0d57935a0f1311ef28b093370a5601ce1d",
          "openTarget": 2,
          "openType": 1,
          "showType": 0
        },
        {
          "children": [],
          "label": "学校邮箱",
          "value": "",
          "iconUrl": "",
          "publicId": "3a0e69045a0f1311ef28b09881d1d33aec4c",
          "openTarget": 2,
          "openType": 1,
          "showType": 0
        },
        {
          "children": [],
          "label": "友情链接",
          "value": "",
          "iconUrl": "",
          "publicId": "3a0fa1852a0f1311ef28b092d3cdd93dfb53",
          "openTarget": 2,
          "openType": 1,
          "showType": 0
        }
      ],
      "label": "院系设置",
      "value": "",
      "iconUrl": "",
      "publicId": "3a09ae101a0f1311ef28b094df7fa086ebdd",
      "openTarget": 2,
      "openType": 1,
      "showType": 1
    }
  ],
  "topNavBoxShadowBlur": [],
  "selectBoxShadowBlur": [],
  "liHoverFontColorArr": {
    "data": {
      "stops": [
        [
          "rgba(107, 107, 131, 1)",
          0
        ],
        [
          "rgba(255, 255, 255, 0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color"
  },
  "liActiveBorderColor": {
    "data": {
      "stops": [
        [
          "rgba(61,130,242,1)",
          0
        ],
        [
          "rgba(61,130,242,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(61,130,242,1)"
  },
  "selectBoxShadowSpread": [],
  "topNavBoxShadowV": [],
  "liHoverBorderColor": {
    "data": {
      "stops": [
        [
          "rgba(240,242,247,1)",
          0
        ],
        [
          "rgba(240,242,247,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(240,242,247,1)"
  },
  "liFontColorArr": {
    "data": {
      "stops": [
        [
          "rgba(0,0,0,0.8)",
          0
        ],
        [
          "rgba(255,255,255,0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color",
    "color": "rgba(0,0,0,0.8)"
  },
  "activeFontColorArr": {
    "data": {
      "stops": [
        [
          "rgba(0,0,0,0.8)",
          0
        ],
        [
          "rgba(255,255,255,0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color",
    "color": "rgba(0,0,0,0.8)"
  },
  "hoverBgColor": [
    {
      "data": {
        "stops": [
          [
            "rgba(232,242,255,1)",
            0
          ],
          [
            "rgba(246,206,1,1)",
            1
          ]
        ],
        "angle": 0
      },
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "rgba(232,242,255,1)"
    }
  ],
  "background": [
    {
      "data": {
        "stops": [
          [
            "rgba(255,255,255,1)",
            0
          ],
          [
            "rgba(246,206,1,1)",
            1
          ]
        ],
        "angle": 0
      },
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "rgba(255,255,255,1)"
    }
  ],
  "liBorderColor": {
    "data": {
      "stops": [
        [
          "rgba(61,130,242,1)",
          0
        ],
        [
          "rgba(61,130,242,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(61,130,242,1)"
  },
  "topNavBackground1": [
    {
      "data": {
        "stops": [
          [
            "rgba(3,89,181,0)",
            0
          ],
          [
            "rgba(246,206,1,1)",
            1
          ]
        ],
        "angle": 0
      },
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "rgba(3,89,181,0)"
    }
  ],
  "topNavBorderColor": {
    "data": {
      "stops": [
        [
          "rgba(200,200,200,1)",
          0
        ],
        [
          "rgba(61,130,242,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(200,200,200,1)"
  },
  "colorArr": {
    "data": {
      "stops": [
        [
          "rgba(0,0,0,0.8)",
          0
        ],
        [
          "rgba(255,255,255,0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color",
    "color": "rgba(0,0,0,0.8)"
  },
  "boxShadowColor": [],
  "topNavBoxShadowH": [],
  "selectBoxShadowV": [],
  "ulBgColor": "rgba(255, 255, 255, 1)",
  "liActiveFontSize": 15,
  "liActiveLineHeight": 38,
  "color": "rgba(107, 107, 131, 1)",
  "label": "新闻公告",
  "liActiveFontColor": "rgba(255, 255, 255, 0.8)",
  "liActiveTextIsThemeColor": true,
 // "value": "39eadb5f8a0f1311ef28b09001ee837bca15",
  "liActiveBgIsThemeColor": true,
  "navWidth": 242,
  "liHoverLineHeight": 38,
  "iconSrc": "342d06f938721111ed0b1a4513396451785f",
  "iconWidth": 16,
  "activeFontSize": 16,
  "hoverIsSameActive": false,
  "hoverTextIsThemeColor": true,
  "hoverLineHeightType": "px",
  "liLineHeightType": "px",
  "fontSize": 16,
  "lineHeight": 38,
  "iconMargin": 2,
  "iconColor": "rgba(0, 0, 0, 0.2)",
  "activeFontWeight": 600,
  // "widthType": "%",
  // "widthAuto": true,
  // "height": "auto",
  // "heightType": "自动",
  "liHoverLineHeightType": "px",
  "topNavBorderWidth": [0, 0, 0, 0],
  "topNavTextLimitCount": 8,
  "borderTopLeftRadius": 8,
  "borderTopRightRadius": 8,
  "borderBottomLeftRadius": 8,
  "borderBottomRightRadius": 8,
  "activeLineHeightType": "px",
  "liHoverFontSize": 15,
  "liHoverFontColor": "rgba(255, 255, 255, 0.8)",
  "liHoverFontWeight": 700,
  "liHoverBgIsThemeColor": true,
  "activeLineHeight": 38,
  "activeFontColor": "rgba(255, 255, 255, 1)",
  "hoverFontSize": 16,
  "hoverFontWeight": 600,
  "liHoverTextIsThemeColor": true,
  "liActiveLineHeightType": "px",
  "lineHeightType": "px",
  "activeTextIsThemeColor": true,
  "liBgIsThemeColor": false,
  "hoverLineHeight": 38,
  "liBgColor": "rgba(0,0,0,0)",
  "liHeight": 40,
  "liWidth": 160,
  "topNavBorderTypeFlag1": 2,
  "topNavBorderTopLeftRadius1": 0,
  "textShadowBlur": 0,
  "topNavBorderBottomRightRadius1": 0,
  "topNavBorderTopRightRadius1": 0,
  "topNavBorderBottomLeftRadius1": 0,
  "indent": 16,
  "liFontSize": 15,
  "liLineHeight": 38,
  "liFontColor": "rgba(107, 107, 131, 1)",
  "topNavTextLimit1": true,
  "topNavTextLimitCount1": 8,
  "cover": require("../../../assets/images/leftMenu/navMenuVertical/style1-pc.png"),
}]

/**
 * 大屏返回默认配置数据
 */
export const bs = [{
  bgColor: '#1F2124',
  color: 'rgba(255, 255, 255, 0.8)',
  activeBgColor: 'rgba(43, 103, 255, 0.1)',
  activeFontColor: 'rgba(43, 103, 255, 1)',
  hoverBgColor: 'rgba(43, 103, 255, 0.1)',
  liHoverBgColor: 'rgba(43, 103, 255, 0.1)',
  liFontColor: 'rgba(255, 255, 255, 0.8)',
  liActiveBgColor: 'rgba(43, 103, 255, 0.1)',
  selectBoxShadowColor: [],
  liActiveFontColor: 'rgba(43, 103, 255, 1)',
  iconColor: 'rgba(255, 255, 255, 0.6)',
  topNavBgColor: '#1F2124'
}]

/**
 * app返回默认配置数据
*/
export const appHome = [{
  // "widthType": "%",
  // "widthAuto": true,
  // "height": "auto",
  // "heightType": "自动",
  "borderColor": {
    "data": {
      "stops": [
        [
          "#3D82F2",
          0
        ],
        [
          "#3D82F2",
          1
        ]
      ],
      "angle": 0
    },
    "color": "#3D82F2"
  },
  "activeBgColor": [
    {
      "data": {
        "stops": [
          [
            "rgba(3,89,181,0)",
            0
          ],
          [
            "rgba(246,206,1,1)",
            1
          ]
        ],
        "angle": 0
      },
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "rgba(3,89,181,0)"
    }
  ],
  "topNavBackground": [
    {
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "#fff"
    }
  ],
  "liHoverBgColor": [
    {
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "#F0F2F7"
    }
  ],
  "activeBorderColor": {
    "data": {
      "stops": [
        [
          "rgba(243,243,243,1)",
          0
        ],
        [
          "rgba(61,130,242,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(243,243,243,1)"
  },
  "liActiveBgColor": [
    {
      "data": {
        "stops": [
          [
            "rgba(3,89,181,0)",
            0
          ],
          [
            "rgba(246,206,1,1)",
            1
          ]
        ],
        "angle": 0
      },
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "rgba(3,89,181,0)"
    }
  ],
  "liActiveFontColorArr": {
    "data": {
      "stops": [
        [
          "rgba(0,0,0,0.8)",
          0
        ],
        [
          "rgba(255, 255, 255, 0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color"
  },
  "selectOptions": [
    {
      "label": "首页",
      "value": "/",
      "iconUrl": "",
      "publicId": "39e954be7a0f1311ef28b092133944acb1bc",
      "openTarget": 2,
      "openType": 2,
      "showType": 0,
      "children": []
    },
    {
      "label": "新闻公告",
      "value": "",
      "iconUrl": "",
      "publicId": "39eadb5f8a0f1311ef28b09001ee837bca15",
      "openTarget": 2,
      "openType": 2,
      "showType": 2,
      "children": [
        {
          "label": "数据列表",
          "value": "",
          "iconUrl": "",
          "publicId": "39ec89105a0f1311ef28b094c572b5a57592",
          "openTarget": 2,
          "openType": 1,
          "showType": 1,
          "children": []
        },
        {
          "label": "数据列表+简介",
          "value": "",
          "iconUrl": "",
          "publicId": "39f7d3b65a0f1311ef28b0934b044fd9b752",
          "openTarget": 2,
          "openType": 1,
          "showType": 3,
          "children": []
        },
        {
          "label": "简介",
          "value": "",
          "iconUrl": "",
          "publicId": "3a047dec8a0f1311ef28b090edf9680bd622",
          "openTarget": 2,
          "openType": 1,
          "showType": 2,
          "children": []
        }
      ]
    },
    {
      "label": "学校概况",
      "value": "",
      "iconUrl": "",
      "publicId": "3a05dd7d5a0f1311ef28b09029e92da930fb",
      "openTarget": 2,
      "openType": 1,
      "showType": 1,
      "children": [
        {
          "label": "培训讲座",
          "value": "",
          "iconUrl": "",
          "publicId": "3a073d0e3a0f1311ef28b0937d313536bb60",
          "openTarget": 2,
          "openType": 1,
          "showType": 0,
          "children": []
        },
        {
          "label": "新生专栏",
          "value": "",
          "iconUrl": "",
          "publicId": "3a089c9f1a0f1311ef28b09575ec43f54907",
          "openTarget": 2,
          "openType": 1,
          "showType": 0,
          "children": []
        }
      ]
    },
    {
      "label": "院系设置",
      "value": "",
      "iconUrl": "",
      "publicId": "3a09ae101a0f1311ef28b094df7fa086ebdd",
      "openTarget": 2,
      "openType": 1,
      "showType": 1,
      "children": [
        {
          "label": "学校主页",
          "value": "",
          "iconUrl": "",
          "publicId": "3a0ae6916a0f1311ef28b09417eb4ff8893b",
          "openTarget": 2,
          "openType": 1,
          "showType": 0,
          "children": []
        },
        {
          "label": "学校简介",
          "value": "",
          "iconUrl": "",
          "publicId": "3a0c1f122a0f1311ef28b091797b17149caf",
          "openTarget": 2,
          "openType": 1,
          "showType": 0,
          "children": []
        },
        {
          "label": "参观交流",
          "value": "",
          "iconUrl": "",
          "publicId": "3a0d57935a0f1311ef28b093370a5601ce1d",
          "openTarget": 2,
          "openType": 1,
          "showType": 0,
          "children": []
        },
        {
          "label": "学校邮箱",
          "value": "",
          "iconUrl": "",
          "publicId": "3a0e69045a0f1311ef28b09881d1d33aec4c",
          "openTarget": 2,
          "openType": 1,
          "showType": 0,
          "children": []
        },
        {
          "label": "友情链接",
          "value": "",
          "iconUrl": "",
          "publicId": "3a0fa1852a0f1311ef28b092d3cdd93dfb53",
          "openTarget": 2,
          "openType": 1,
          "showType": 0,
          "children": []
        }
      ]
    }
  ],
  "selectBoxShadowBlur": [],
  "liHoverFontColorArr": {
    "data": {
      "stops": [
        [
          "rgba(0,0,0,0.8)",
          0
        ],
        [
          "rgba(255, 255, 255, 0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color"
  },
  "liActiveBorderColor": {
    "data": {
      "stops": [
        [
          "rgba(243,243,243,1)",
          0
        ],
        [
          "rgba(61,130,242,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(243,243,243,1)"
  },
  "selectBoxShadowSpread": [],
  "liHoverBorderColor": {
    "data": {
      "stops": [
        [
          "#F0F2F7",
          0
        ],
        [
          "#F0F2F7",
          1
        ]
      ],
      "angle": 0
    },
    "color": "#F0F2F7"
  },
  "liFontColorArr": {
    "data": {
      "stops": [
        [
          "rgba(0,0,0,0.8)",
          0
        ],
        [
          "rgba(255, 255, 255, 0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color"
  },
  "activeFontColorArr": {
    "data": {
      "stops": [
        [
          "rgba(0,0,0,0.8)",
          0
        ],
        [
          "rgba(255, 255, 255, 0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color"
  },
  "background": [
    {
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "#fff"
    }
  ],
  "liBorderColor": {
    "data": {
      "stops": [
        [
          "rgba(243,243,243,1)",
          0
        ],
        [
          "rgba(61,130,242,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(243,243,243,1)"
  },
  "topNavBackground1": [
    {
      "label": "颜色",
      "isThemeColor": false,
      "type": "color",
      "color": "#fff"
    }
  ],
  "topNavBorderColor": {
    "data": {
      "stops": [
        [
          "rgba(243,243,243,1)",
          0
        ],
        [
          "rgba(61,130,242,1)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "type": "color",
    "color": "rgba(243,243,243,1)"
  },
  "colorArr": {
    "data": {
      "stops": [
        [
          "rgba(0,0,0,0.8)",
          0
        ],
        [
          "rgba(255,255,255,0.8)",
          1
        ]
      ],
      "angle": 0
    },
    "label": "颜色",
    "isThemeColor": false,
    "type": "color",
    "color": "rgba(0,0,0,0.8)"
  },
  "selectBoxShadowV": [],
  "liActiveFontSize": 16,
  "liActiveLineHeight": 56,
  "label": "数据列表",
  "liActiveTextIsThemeColor": true,
  "liActiveBorderWidth": [0, 0, 1, 0],
  // "value": "39e954be7a0f1311ef28b092133944acb1bc",
  "liActiveBgIsThemeColor": false,
  "liHoverFontStyle": "normal",
  "selectFontFamily": "sans-serif",
  "innerElement": "cxNavMenuVertical",
  "selectBorderStyle": "solid",
  "navWidth": 106,
  "iconSrc": "5CB4CFFC9CE56FF2",
  "iconWidth": 20,
  "menuName": "树形菜单",
  "activeFontSize": 16,
  "liLineHeightType": "px",
  "fontSize": 16,
  "lineHeight": 56,
  "iconColor": "rgba(0, 0, 0, 0.6)",
  "liHoverLineHeightType": "px",
  "activeBorderWidth": [0, 0, 1, 0],
  "topNavBorderWidth": [0, 0, 1, 0],
  "topNavTextLimitCount": 8,
  "liHoverIsSameActive": true,
  "activeLineHeightType": "px",
  "activeLineHeight": 56,
  "liActiveLineHeightType": "px",
  "lineHeightType": "px",
  "activeTextIsThemeColor": true,
  "topNavBorderTypeFlag1": 2,
  "topNavBorderTopLeftRadius1": 0,
  "topNavBorderBottomRightRadius1": 0,
  "topNavBorderTopRightRadius1": 0,
  "liBorderWidth": [0, 0, 1, 0],
  "topNavBorderBottomLeftRadius1": 0,
  "indent": 20,
  "liFontSize": 16,
  "liLineHeight": 56,
  "topNavTextLimit1": true,
  "topNavTextLimitCount1": 8,
  "cover": require("../../../assets/images/leftMenu/navMenuVertical/style1-h5.png")
}]
